<template>
<div>
    <BaseEditPage
        :context="context+'s'"
        :alvqa="alvqa"
        cancelIconRoute="/label/tracks"
    >
<!-- HEADLINE -->    
        <template v-slot:headline="{ data }">
            <div class="d-flex align-center" style="margin-top: 8px;">
                <div :alvqa="alvqa + '-title'" style="display: flex; align-items: center;">
                    {{ data.title ? data.title : $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED')}}
                </div>
                <div class="ml-2" style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;">
                    <ContextHelpIcon 
                        v-if="hasContextHelp && (data.title || $route.params.alvId === 'new')"
                        context="LabelTracksEdit"
                        :alvqa="alvqa + '-context-help-icon'"
                    />
                </div>
            </div>
        </template>
        <template v-slot:editForm="{ data }">
            <!-- 1st col -->
            <v-col cols="2">
                <v-row>
                    <v-col>
                        <v-img
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >Track</v-row>
                        </v-img>
                    </v-col>
                </v-row>   
                <!-- <v-row>
                    <v-col>
                        <BaseButton 
                            @click="uploadAudio()"
                            label="lang_LABEL_TRACKS_BUTTON_CAPTION_UPLOAD_MP3"
                            icon="cloud_upload"
                            block
                        />
                    </v-col>
                </v-row>   -->
                <!-- <v-row class="mt-1">
                    <v-col >
                    <BaseButton 
                        icon="cloud_download"
                        label="MP3/WAV runterladen"
                        color="buttonStandard"
                        block
                    />
                    </v-col>
                </v-row>

                <v-row class="mt-1">
                    <v-col >
                    <BaseButton 
                        icon="delete"
                        label="MP3/WAV löschen"
                        color="buttonStandard"
                        block
                    />
                    </v-col>
                </v-row> -->
            </v-col>            

            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_TITLE')"
                        :context="context"
                        field="TrackTitle"
                        rules="required"
                        :alvqa="alvqa + '-textfield-track-title'"
                    />
                </v-row>

                 <!-- <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASE_CAPTION_FIRST_MAIN_ARTIST')" 
                        field="Artist"
                        :context="context"
                        rules="required"
                        :alvqa="alvqa + '-textfield-artist'"
                    /> 
                </v-row> -->
                <v-row>
                    <v-col class="pa-0 ma-0" cols="10">
                        <BaseReadOnlyTextField
                            :innerValue="getAzName"
                            :label="$t('lang_LABEL_RELEASES_CAPTION_ARTIST')"
                            :alvqa="alvqa + '-textfield-interpret'"
                            rules="isTrackArtistObject"
                            :iconTooltipText="$t('lang_LABEL_CAPTION_TOOLTIP_ARTIST_TYPE') + (data.artist && data.artist.alvId ? ' [' + data.artist.alvId + ']' : '')"  
                        />
                    </v-col>
                    <v-col class="justify-end d-flex ml-0 pl-0" cols="2">
                        <BaseIcon   
                            :alvqa="alvqa + '-icon-edit-interpret-connection'"
                            :icon="isArtistConnected ? 'delete' : 'edit'" 
                            :tooltipText="isArtistConnected ? 'lang_GENERIC_CAPTION_DELETE' : 'lang_GENERAL_CAPTION_ICON_EDIT'"   
                            @click="editConnectedArtist()"
                        />
                    </v-col>
                </v-row>
            
                <v-row>
                    <v-col class="pa-0 ma-0" cols="10">
                        <BaseReadOnlyTextField
                            :innerValue="getWorkTitle"
                            :label="$t('lang_LABEL_TRACKS_CAPTION_LINKED_WORK')"
                            :alvqa="alvqa + '-textfield-work-title'"
                            :iconTooltipText="getWorkTooltipTxt()"
                        />
                    </v-col>
                    <v-col class="justify-end d-flex ml-0 pl-0" cols="2">
                        <BaseIcon   
                            :alvqa="alvqa + '-icon-edit-work-connection'"
                            :icon="isWorkConnected ? 'delete' : 'edit'" 
                            :tooltipText="isWorkConnected ? 'lang_GENERIC_CAPTION_DELETE' : 'lang_GENERAL_CAPTION_ICON_EDIT'"   
                            @click="editConnectedWork()"
                        />
                    </v-col>
                </v-row>
                
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_TRACK_LINKED_RELEASES')" 
                        :clearable="false"        
                        :items="getReleasesItems" 
                        :context="context"
                        field="SelectedReleaseId"
                        :alvqa="alvqa + '-dropdown-releases'"
                    />
                </v-row>
               <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_VERSION')"  
                        field="Version"
                        :context="context"
                        :alvqa="alvqa + '-textfield-track-version'"
                    />
                </v-row>
               <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_TITLE2')"  
                        field="TrackName2"
                        :context="context"
                        :alvqa="alvqa + '-textfield-track-title-2'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_TITLE3')" 
                        field="TrackName3"
                        :context="context"
                        :alvqa="alvqa + '-textfield-track-title-3'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_TITLE4')" 
                        field="TrackName4"
                        :context="context"
                        :alvqa="alvqa + '-textfield-track-title-4'"
                    />
                </v-row>
                <!-- <v-row>
                    <BaseEditPageTextField 
                        :label="trackTitle5Label" 
                        field="TrackName5"
                        :context="context"
                        :alvqa="alvqa + '-textfield-track-title-5'"
                    />
                </v-row> -->
            </v-col>
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_ISRC')" 
                        field="ISRC"
                        :context="context"
                        :alvqa="alvqa + '-textfield-isrc'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_ISRC2')" 
                        field="ISRC2"
                        :context="context"
                        :alvqa="alvqa + '-textfield-isrc-2'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_ISRC3')"
                        field="ISRC3"
                        :context="context"
                        :alvqa="alvqa + '-textfield-isrc-3'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_ISRC4')" 
                        field="ISRC4"
                        :context="context"
                        :alvqa="alvqa + '-textfield-isrc-4'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_OTHER_ID')" 
                        field="OtherCode"
                        :context="context"
                        :alvqa="alvqa + '-textfield-other-code'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_TAGS')"  
                        field="Tags"
                        :context="context"
                        :alvqa="alvqa + '-textfield-tags'"
                    />
                </v-row>
                <v-row> 
                    <BaseEditPageTextarea 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_NOTES')"  
                        field="Notes"
                        :context="context"
                        :alvqa="alvqa + '-textfield-notes'"
                    />
                </v-row>
            </v-col>
            <v-col cols="2">
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_DURATION')" 
                        field="Duration"
                        :context="context"
                        rules="duration"
                        :alvqa="alvqa + '-textfield-duration'"
                    />
                </v-row>
                        <!-- {{ $d(getEditTrack.initialDate, 'short', this.$i18n.locale) }} -->
                        <!-- :value="$d(getEditTrack.initialDate, 'short', this.$i18n.locale)" -->
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="RightsOwnershipFrom"
                        :label="$t('lang_LABEL_TRACKS_CAPTION_RIGHTS_OWNERSHIP_FROM')"
                        :alvqa="alvqa + '-datepicker-rights-ownership-from'"
                    />
                </v-row>
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="InitialDate"
                        :label="$t('lang_LABEL_TRACKS_CAPTION_DATE_INITIAL')"
                        :alvqa="alvqa + '-datepicker-initial_date'"
                    />
                </v-row>
                 
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_P_NOTICE')" 
                        field="Copyright"
                        :context="context"
                        :alvqa="alvqa + '-textfield-copyright'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_CLASSICAL_WORK')" 
                        field="ClassicalWork"
                        :context="context"
                        :alvqa="alvqa + '-textfield-classical-work'"
                    />
                </v-row>
                  <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_LANGUAGE')" 
                        :items="$alvPlugin.getListOfGenericMusicLanguages('label-tracks')" 
                        :context="context"
                        field="SelectedLanguageId"
                        :alvqa="alvqa + '-dropdown-language'"
                    />              
                </v-row>
                <v-row class="pb-0">
					<DropdownFilter 
                        :context="context + 'Year'"
                        label="lang_LABEL_TRACKS_CAPTION_YEAR_OF_RECORDING"
                        itemText="text"
						class="mx-4"
                        :items="yearsOptions"
						:hideErrorMessage="false"
                        :alvqa="alvqa + '-dropdown-track-years-filter'"
                    />   
                </v-row>
                <v-row class="mt-n5">
                    <BaseEditPageDropdown 
                        :context="context"
                        :label="$t('lang_LABEL_TRACKS_CAPTION_COUNTRY_OF_RECORDING')"
                        field="Country"
                        :items="countries"
                        class="mt-6"
                        :alvqa="alvqa + '-dropdown-country'"
                    />   
                </v-row>
            </v-col>
            <v-col cols="2">                
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_EXPLICIT')"
                        :items="getYesOrNo('explicit')"
                        :context="context"
                        field="Explicit"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-explicit'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_LIVE')"
                        :items="getYesOrNo('live')"
                        :context="context"
                        field="Live"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-live'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_INSTRUMENTAL')"
                        :items="getYesOrNo('instrumental')"
                        :context="context"
                        field="Instrumental"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-instrumental'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_LABEL')" 
                        :items="getLabelsItems" 
                        :context="context"
                        field="SelectedLabelId"
                        :clearable="false" 
                        rules="required"
                        :alvqa="alvqa + '-dropdown-label-companies'"
                    />
                </v-row>                
            </v-col>
        </template>   

<!-- PANELS -->
        <template v-slot:panels>
            <ConnectWorkToTrackDialog />
            <ConnectArtistToTrackDialog />
            <DeletionDialog :useContextSetinVuex="true" />

            <!-- ARTISTS -->
            <TracksArtistsEditPanel />
            <TracksArtistsEditPanelDialog />
            <!-- MEDIA -->
            <TracksMediaEditPanel />
            <MediaFileUploadDialog 
                acceptedFiles='.png,.jpg,.jpeg,.pdf,.txt,.mp4,.wav,.mov,.mp3,.mpeg,.flac,.zip'
                placeholder='lang_LABEL_TRACKS_EDIT_AUDIO_UPLOADER_TEXT_UPLOAD_MEDIA_FILES'
                headline="lang_GENERICL_AUDIO_UPLOAD_DIALOG_TITLE" 
                :context="context + 'sMedia'"
                detailsCall="getTracksDetails"
                directory="label/tracks/"
            />
            <TracksGlocEditPanel />
            <TracksGlocEditPanelDialog />
            <!-- OTHER IDS -->
            <TracksOtherIdsEditPanel />
            <TracksOtherIdsEditPanelDialog />
        </template>
    </BaseEditPage>

    <!-- Context Help Dialog -->
    <ContextHelpDialog />
</div>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseReadOnlyTextField from '@/components/_readonly/BaseReadOnlyTextField'
import DropdownFilter from '@/components/_filters/DropdownFilter'

import TracksArtistsEditPanel from './_panels/1_artists/TracksArtistsEditPanel'
import TracksMediaEditPanel from './_panels/2_media/TracksMediaEditPanel.vue'
import TracksGlocEditPanel from './_panels/3_gloc/TracksGlocEditPanel'
import TracksGlocEditPanelDialog from './_panels/3_gloc/TracksGlocEditPanelDialog'
import TracksOtherIdsEditPanel from './_panels/4_otherids/TracksOtherIdsEditPanel'
import TracksOtherIdsEditPanelDialog from './_panels/4_otherids/TracksOtherIdsEditPanelDialog'

import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import MediaFileUploadDialog from '@/components/_dialogs/MediaFileUploadDialog'
import TracksArtistsEditPanelDialog from './_panels/1_artists/TracksArtistsEditPanelDialog'
import ConnectWorkToTrackDialog from '../_dialogs/ConnectWorkToTrackDialog'
import ConnectArtistToTrackDialog from '../_dialogs/ConnectArtistToTrackDialog'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon'
import ContextHelpDialog from '@/components/_dialogs/ContextHelpDialog'

import {    DropdownGenericYesNo,
        } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "TracksEdit",
    data(){
        return {
            context: "Track",
            releasesDropdown: [],
            alvqa: "label-tracks-edit-form",
            hasContextHelp: false
        }
    },
    components: {   
        BaseEditPage,
        BaseEditPageTextField,
        BaseButton,
        BaseIcon,
        BaseEditPageTextarea,
        BaseEditPageDropdown,
        BaseEditPageDatePicker,
        BaseReadOnlyTextField,
		DropdownFilter,

        TracksArtistsEditPanel,
        TracksMediaEditPanel,
        TracksGlocEditPanel,
        TracksGlocEditPanelDialog,
        TracksOtherIdsEditPanel,
        TracksOtherIdsEditPanelDialog,

        DeletionDialog,
        MediaFileUploadDialog,
        TracksArtistsEditPanelDialog,
        ConnectWorkToTrackDialog,
        ConnectArtistToTrackDialog,
        ContextHelpIcon,
        ContextHelpDialog,
    },
    computed: {      
        yearsOptions(){
            let years = [];
            let maxYear = new Date().getFullYear()+1

            for(let i = maxYear; i >= 1901; i--) {
                years.push(
                    {
                        text: i.toString(),
                        value: i, 
                        alvqa: this.alvqa + '-dropdown-period-selector-years-' + i
                    }
                )
            } 
            return years
            
        },  
		countries() {
            return this.$alvPlugin.getListOfTranslatedCountries()
        },
        getReleasesItems()      { return this.$store.getters.getReleasesDropdown },
        getLabelsItems()        { 
            let labelArr
            let labels = this.$store.getters.getLabelsDropdown 
            if(labels !== undefined) {
                labelArr = JSON.parse(JSON.stringify(labels))
                labelArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-label-companies-' + element.value
                    element["text"]= element.text + ' (' + element.alvId + ')'
                });
            } else {
                labelArr = []
            }
            return labelArr 
        },
        isWorkConnected() { return this.getWorkTitle !== null },
        isArtistConnected() { return this.getAzName !== null },
        getWorkTitle() { return this.$store.getters.getTrackDetailsConnectedWork },
        getAzName() { return this.$store.getters.getTrackDetailsConnectedArtist }
    },
    methods: {
        getYesOrNo(alvqaContext) {
            let dropdownOptions = JSON.parse(JSON.stringify(DropdownGenericYesNo))
            dropdownOptions.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-' + alvqaContext+ '-' + element.value
                })                
            return dropdownOptions
        },
        getWorkTooltipTxt(){
            let tooltipTxt = ''
            let work = this.$store.getters.getTracksDetails.work

            if(work !== undefined && work !== null){
                tooltipTxt = work.title + " ("
                work.alvId !== null && work.alvId !== undefined && work.alvId !== '' ? tooltipTxt += work.alvId : tooltipTxt += ''
                work.gemaNumber !== undefined && work.gemaNumber !== null && work.gemaNumber !== '' ? tooltipTxt += ' | ' + work.gemaNumber : tooltipTxt += ''
                tooltipTxt += ")"
            }

            return tooltipTxt


        },
        uploadAudio() {
            this.$store.commit('setSnackbar', {
                type: 'warning',
                msg: "This page is under construction. This function is not added yet!"
            })
        },
        editConnectedWork(){
            if(this.isWorkConnected) this.$store.dispatch('deleteWorkTrackConnection')
            else this.$store.commit('setShowSearchDialog', true)
        },
        editConnectedArtist() {
            if(this.isArtistConnected) this.$store.dispatch('deleteArtistTrackConnection')
            else this.$store.commit('setShowConnectArtistDialog', true)
        },
        },
    async created() {
        this.hasContextHelp = await this.$alvPlugin.checkContextHelpAvailability('LabelTracksEdit')
    }
}
</script>